import {ReactNode} from 'react';

import {RootLayer} from '@sail/ui';

import {
  AppConfig,
  AppProfile,
  AppProvider,
  InlineDataProvider,
} from '@stripe-internal/conversations-assistant';
import {
  FeatureFlagsProvider as ConvUIFlagsProvider,
  type FeatureFlags as ConvUIIFlags,
  ThemeProvider as ConvUIThemeProvider,
} from '@stripe-internal/conversations-ui';
import {DefaultInlineDataComponentRegistry} from '@stripe-internal/mse-inline-data';

const mobileConvUIFlags: ConvUIIFlags = {
  newUniversalHelpDesign: true,
  universalHelpDotComDesign: false,
  dotComFeedbackButtons: false,
  dotComNoLlm: false,
  dotComCsf: false,
  messagesTopAnchored: false,
  inlineRacEmailForm: true,
  universalHelpDrawerEnabled: false,
  conversationsLiveAnswersRow: true,
  universalHelpEncourageMoreDetailFromUserMse5042: false,
  enableScreenshareUi: false,
};

type Props = {
  config: AppConfig;
  profile: AppProfile;
  children: ReactNode;
};

export function MobileAssistantProviders({config, profile, children}: Props) {
  return (
    <ConvUIThemeProvider>
      <RootLayer>
        <AppProvider config={config} profile={profile}>
          <InlineDataProvider components={DefaultInlineDataComponentRegistry}>
            <ConvUIFlagsProvider value={mobileConvUIFlags}>
              {children}
            </ConvUIFlagsProvider>
          </InlineDataProvider>
        </AppProvider>
      </RootLayer>
    </ConvUIThemeProvider>
  );
}
